import { Workbox } from 'workbox-window';

export function register() {
  if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
    const sw = new Workbox('/sw.js');

    sw.addEventListener('activated', () => {
      // eslint-disable-next-line no-console
      console.log('%c [Service Worker] activated', 'color: #bada55');
    });

    void sw.register();
  } else {
    unregister();
  }
}

function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then((registration) => {
        // eslint-disable-next-line no-console
        console.log('%c [Service Worker] unregistered', 'color: #bada55');
        void registration.unregister();
      })
      .catch((error) => {
        console.error('%c [Service Worker] error unregistering: ', error.message);
      });
  }
}
